import { SxProps, Tab, Tabs, Theme } from '@mui/material'
import React, { ReactElement } from 'react'
import { defaultTheme } from '../../../theme/index'
import styled from 'styled-components'
import { breakpoints } from '../../../theme/breakpoints'

interface StyledTabsProps {
  children?: React.ReactNode
  value: number
  onChange: (event: React.SyntheticEvent, newValue: number) => void
  sx?: SxProps<Theme>
  variant?: 'standard' | 'scrollable' | 'fullWidth'
}

export const CustomTabs = styled((props: StyledTabsProps) => (
  <Tabs
    {...props}
    variant={props.variant || 'standard'}
    TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
  />
))({
  borderBottom: '1px solid #e8e8e8',
  '& .MuiTabs-indicator': {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    height: 4,
  },
  '& .MuiTabs-indicatorSpan': {
    width: '100%',
    backgroundColor: defaultTheme.colors.primary,
    height: 4,
  },
})

interface StyledTabProps {
  label: string
  value: number | string
  sx?: SxProps<Theme>
}

export const CustomTab = (props: StyledTabProps): ReactElement => (
  <StyledTab disableRipple {...props} />
)

const StyledTab = styled(Tab)`
  text-transform: none;
  min-width: 0;
  color: ${({ theme }) => theme.colors.columnBorder};
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  padding: 10px 20px;

  &:hover {
    color: #000000;
    opacity: 1;
  }

  &.Mui-selected {
    color: #000000;
  }

  &.Mui-focusVisible {
    background-color: ${({ theme }) => theme.colors.primary};
  }

  @media (width <= ${breakpoints.tablet}px) {
    font-size: 14px;
  }
`
